let refreshing: Promise<boolean> | null = null;

export async function tryRefreshToken(): Promise<boolean> {
  if (refreshing) return refreshing;

  refreshing = (async () => {
    try {
      const response = await fetch('/api/auth/refresh', {
        method: 'POST',
        credentials: 'include',
      });
      return response.ok;
    } catch {
      return false;
    } finally {
      refreshing = null;
    }
  })();

  return refreshing;
}
